import {
	alias,
	deserialize,
	getDefaultModelSchema,
	identifier,
	list,
	object,
	serializable,
} from "serializr";
import { IJsonObject } from "../api";
import { Opportunity } from "../opportunities/Opportunity";
import { Project } from "./Project";

interface IProps {
	id?: number | null;
	name?: string;
	notes?: string;
	amount?: number;
	amountPaid?: number;
	amountPending?: number;
	amountAllocated?: number;
	amountAvailable?: number;
	accountId?: number;
	opportunities?: Opportunity[];
	projects?: Project[];
}

export class ProjectBudget {
	public static fromJson(json: IJsonObject): ProjectBudget {
		return deserialize(ProjectBudget, json);
	}

	public static fromJsonArray(json: IJsonObject[]): ProjectBudget[] {
		return json.map((user: IJsonObject) => this.fromJson(user));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public name: string;

	@serializable
	public notes: string;

	@serializable
	public amount: number;

	@serializable(alias("amount_paid"))
	public amountPaid: number;

	@serializable(alias("amount_pending"))
	public amountPending: number;

	@serializable(alias("amount_allocated"))
	public amountAllocated: number;

	@serializable(alias("amount_available"))
	public amountAvailable: number;

	@serializable(alias("account_id"))
	public accountId: number;

	@serializable(list(object(Opportunity)))
	public opportunities: Opportunity[];

	public projects: Project[];

	constructor({
		id = 1,
		name = "",
		notes = "",
		amount = 0,
		amountPending = 0,
		amountPaid = 0,
		amountAllocated = 0,
		amountAvailable = 0,
		accountId = 0,
		opportunities = [],
		projects = [],
	}: IProps = {}) {
		this.id = id;
		this.name = name;
		this.notes = notes;
		this.amount = amount;
		this.amountPending = amountPending;
		this.amountPaid = amountPaid;
		this.amountAllocated = amountAllocated;
		this.amountAvailable = amountAvailable;
		this.accountId = accountId;
		this.opportunities = opportunities;
		this.projects = projects;

		getDefaultModelSchema(ProjectBudget).props.projects = list(
			object(Project),
		);
	}
}
